module.exports = __webpack_public_path__ + "img/ic_modal_error.86c12ab3.svg";